import { render, staticRenderFns } from "./MarketData.vue?vue&type=template&id=0b02f709&scoped=true"
import script from "./MarketData.vue?vue&type=script&lang=js"
export * from "./MarketData.vue?vue&type=script&lang=js"
import style0 from "./MarketData.vue?vue&type=style&index=0&id=0b02f709&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b02f709",
  null
  
)

export default component.exports